import React from "react";
import { Container } from "react-bootstrap";
import SpeakerAbout from "../../components/speaking/SpeakerAbout";

const OurImpact = () => {
  return (
    <Container className="my-5">
      <div className="mb-5">
        <h2 className="fw-bold mb-4">Our Reach & Impact</h2>
        <div className="fs-4 mb-3">
          <p> Inspired over 100,000+ individuals through 250+ live sessions and digital content.</p>
          <p> Counseled 4,000+ people over the last 15 years.</p>
          <p> Worked one-on-one with 200+ high-paying clients for strategic business growth.</p>
          <p> Hosted Audit Your Life, Business & Income, our flagship annual event that attracts 3,000+ participants online and offline each year.</p>
          <p> Built a thriving digital community focused on shared growth, learning, and collaboration.</p>
        </div>
      </div>

      <div className="mb-5">
        <h2 className="fw-bold mb-4">Our 9 Flagship Training Programs</h2>
        <div className="fs-4 mb-2 fw-semibold">
          <p> Audit Your Life, Business & Income (Entrepreneurs, Business Owners, CEO's, Executive, Professional, Students, any Go getters)</p>
          <p> Launch Code – Turn ideas into income with powerful business models.</p>
          <p> Growth Code – Marketing, branding & lead generation strategies.</p>
          <p> Scale Code – System, structure & automation for scaling.</p>
          <p> Wealth Code – Personal finance, savings, investments & wealth.</p>
          <p> Sales Code – High-conversion sales strategies and communication.</p>
          <p> Digital Code – Digital business, freelancing & monetization systems.</p>
          <p> Investment Code – Smart investing principles and portfolio building.</p>
          <p> Career Code – Career growth, leadership & high-income skills.</p>
        </div>
        <p className="fs-4">Each program is tailored to specific needs, whether you're just starting or already established.</p>
      </div>

      <div className="mb-5">
        <h2 className="fw-bold mb-4">Our Core Focus Areas</h2>
        <div className="fs-4 mb-2">
          <p> Psychological Health – Mindset, confidence, and clarity.</p>
          <p> Physical Health – Energy, health, and discipline.</p>
          <p> Emotional Health – Control, relationships, and inner balance.</p>
          <p> Financial Health – Income, budgeting, and wealth creation.</p>
          <p> Spiritual Health – Purpose, peace, and long-term vision.</p>
        </div>
      </div>

      <div className="mb-5">
        <h1 className="fw-bold mb-4">What We Offer</h1>
        <div className="fs-4 mb-3">
          <p> Live and recorded training programs for beginner to advanced levels.</p>
          <p> Affordable content access to level the playing field for new learners.</p>
          <p> One-on-one consulting services from single sessions to long-term agreements for high achievers.</p>
          <p> Affiliate and membership programs to reduce unemployment and help individuals earn active or passive income.</p>
          <p> Paid keynote speaking sessions on entrepreneurship, sales, mindset, marketing, motivation, investment, and wealth.</p>
        </div>
      </div>

      <div className="mb-5">
        <h2 className="fw-bold mb-4">Our Vision</h2>
        <div className="fs-4">
          <p>
            To reach 8 billion people globally and help at least 1 billion people directly over the next 10 years through education, consulting, community, and collaboration.
          </p>
        </div>
      </div>
      <SpeakerAbout/>

      <div className="mb-5">
        <h2 className="fw-bold mb-4">My Values & Beliefs</h2>
        <div className="fs-4 mb-3">
          <p><strong> Keep The Faith On The True Creator:</strong> The first and primary concern we all must have is about our True Creator. We must keep full faith in our True Creator and must not associate partners with Him. At the same time, we must try to follow the teachings of the greatest man on earth in the history of the universe: Prophet Mohammed (sa). We must avoid bid’ah (innovations not based on the authentic teachings of Rasul (sa)).</p>
          <p><strong> Believe In Yourself Even When No One is Believing You:</strong> First rule is to believe in Allah. Second rule is to believe in ourselves, our own intuition or instinct, and not only follow our deep passion but also invest in it and make that dream a reality by following the third rule.</p>
          <p><strong> Create Massive Action Plan & Execute:</strong> We do not get the desired dream life just by thinking, praying, and believing. If we do not take massive action along with those, we won’t succeed. As we all know, massive action is the key to all success.</p>
          <p className="fs-4">
            <em>“If you are born poor that’s not your mistake but if you die poor it’s your mistake.”</em> – Bill Gates
          </p>
        </div>
      </div>
    </Container>
  );
};

export default OurImpact;
